gsap.registerPlugin(ScrollTrigger);
document.addEventListener("DOMContentLoaded", () => {
    const testimonyContent = document.querySelector('.mag-testimony__content');
    let mm = gsap.matchMedia();
    mm.add("(min-width: 1024px)", () => {

        gsap.timeline({
            scrollTrigger: {
                trigger: ".mag-testimony",
                start: "top bottom",
                end: "top center",
                scrub: 2,
            }
        })
            .fromTo(testimonyContent, {
                y: 200,
            }, {
                y: 0,
                duration: 0.5,
                ease: "none"
            });
    });


});